import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Tu hijo no puede terminar una tarea sin distraerse', 'Se frustra a los 2 minutos si algo no sale perfecto', 'Solo está tranquilo con una pantalla enfrente', 'Intentaste actividades alternativas y las abandonó enseguida', 'Sentís que su capacidad de atención se acorta cada semana', 'La creatividad, la lógica y las ganas de aprender desaparecieron', 'Te fuiste a dormir pensando "mañana lo cambio" y mañana fue igual', 'Cada vez que le sacás el celular termina en un berrinche que agota a toda la familia'];
  return <section className="bg-dark-800 py-12 px-4" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <div className="text-center mb-8" data-id="element-140">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-4 leading-tight" data-id="element-141">
            ¿Cuántas noches más vas a terminar sintiéndote culpable?
          </h2>
          <p className="text-lg md:text-xl text-cream/80 mb-3" data-id="element-142">
            Sos un buen padre. Una buena madre. Amás a tu hijo con todo.
          </p>
          <p className="text-base md:text-lg text-cream/70 mb-4" data-id="element-143">
            Pero nadie te dijo que en 2026 ibas a tener que competirle la
            atención a un algoritmo diseñado por los mejores ingenieros del
            mundo para que tu hijo no pueda concentrarse más de 30 segundos.
          </p>
          <p className="text-lg md:text-xl font-semibold text-primary" data-id="element-144">
            No es debilidad tuya. No es mala crianza. Es que el celular gana
            siempre... si no tenés un método.
          </p>
        </div>

        <div className="bg-dark-900 rounded-3xl p-6 md:p-10 border border-urgency/20 shadow-2xl" data-id="element-145">
          <h3 className="text-2xl font-bold text-cream mb-6 flex items-center" data-id="element-146">
            <XCircle className="w-7 h-7 text-urgency mr-3" data-id="element-147" />
            ¿Esto te suena familiar?
          </h3>

          <ul className="space-y-4" data-id="element-148">
            {points.map((point, i) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} key={i} className="flex items-start" data-id="element-149">
                <span className="text-urgency mr-3 text-xl mt-0.5" data-id="element-150">❌</span>
                <span className="text-base md:text-lg text-cream/90" data-id="element-151">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center mt-8" data-id="element-152">
          <p className="text-2xl md:text-3xl font-bold text-cream italic" data-id="element-153">
            ¿Y si este fuera el último día que lo pensás sin hacer nada?
          </p>
        </div>
      </div>
    </section>;
}